// =====================================================================
// useIsMobile — détecte le viewport mobile (Day 11+ 29-05-2026)
// =====================================================================
// Usage:
//   const isMobile = useIsMobile();           // par défaut <= 640px
//   const isMobile = useIsMobile(768);        // breakpoint custom
//
// Pour responsive complet en JSX:
//   {isMobile ? <CardsView /> : <TableView />}
// =====================================================================
import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 640) {
  const get = () => typeof window !== 'undefined' && window.innerWidth <= breakpoint;
  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    const onResize = () => setIsMobile(get());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
